import {
  onboardingBookingDestinationIdSchema,
  onboardingBookingDestinationSchema,
} from "@redotech/redo-onboarding-api/booking-destination";
import * as z from "zod";

export const getBookingDestination = {
  name: "getBookingDestination" as const,
  input: z.object({ productId: onboardingBookingDestinationIdSchema }),
  output: onboardingBookingDestinationSchema,
};
